import React, {useEffect, useState} from "react";
import {Wrapper, TitleDiv, DraftRoomContainer} from './DraftRoom.styles';
import SettingsIcon from "../../assets/icons/settingsIcon.svg";
import Frame from "../../assets/icons/frame.svg";
import DraftRoomComponent from "../../components/DraftRoomComponent/DraftRoomComponent";
import {useParams} from "react-router-dom";
import axiosInstance from "../../service/axiosInstance";
import {API_ENDPOINT} from "../../config/config";
import {toast} from "react-toastify";




function DraftRoom(){

    const { id } = useParams();
    const [draftRoomEvent, setDraftRoomEvent] = useState([]);
    const [loadingRequest, setLoadingRequest] = useState(false);


    const handleGetEventConfig = async () => {
        setLoadingRequest(true);
        try {
            const response = await axiosInstance.get(
                `${API_ENDPOINT}event-config/${id}`,
            );
            const roomData = response.data;
            setDraftRoomEvent(roomData)
        } catch (err) {
            console.error(err);
            toast.error("Error fetching data!");
        } finally {
            setLoadingRequest(false);
        }
    };

    useEffect(() => {
        handleGetEventConfig();
    }, []);


    return(
        <Wrapper className="main-container">
            <TitleDiv>
                <button><img src={SettingsIcon} alt={""}/>Settings</button>
                <div>
                    <img src={Frame} alt="" />
                </div>
            </TitleDiv>
            <DraftRoomContainer>
                <DraftRoomComponent draftRoomEvent={draftRoomEvent}/>
            </DraftRoomContainer>
        </Wrapper>
    )
}

export default DraftRoom;